/**
 * @description
 * Интерфейсы соответствуют полям, которые ожидаются на странице в атрибуте 'data-schedule-item'(или его переопределением).
 * Это данные конкретной карточки(карточка врача/lpu).
 * Если поля совпадать не будут - произойдет ошибка валидации.
 */

export const getLpuItemInterface = (): {
  lpuId: number | null
  hasSlots: string | null
  doctorsLpuHref: string | null
  isAppointmentOn: string | null
  lpuPhone: string
  lpuWorkingText: string
  appointmentType: string
} => ({ // для страниц с запросом календарей lpu
  lpuId: null, // id клиники
  hasSlots: null, // наличие слотов у врачей клиники
  doctorsLpuHref: null, // ссылка на список врачей клиники
  isAppointmentOn: null, // включен ли вывод слотов в клинике
  lpuPhone: '', // номер телефона клиники
  lpuWorkingText: '', // текст ближайшего времени приема
  appointmentType: '', // тип записи (ОЗ/ЭЗ)
})

export const getDoctorsItemInterface = (): {
  wpListId: number[]
  doctorId: number | null
  doctorFio: string | null
  doctorNameShort: string | null
  doctorSpecialtyId: number | null
  hasSpecialPlacement: number
  wpListAppType: { [key: string]: string }[]
  lpuWorkingText: string
  wpListLpuWorkingText: { [key: string]: string }[]
  wpListLpuPhone: { [key: string]: string }[]
} => ({ // для страниц с запросом календарей врачей
  wpListId: [], // список id всех workplaces врача
  doctorId: null, // id врача
  doctorFio: null, // полное имя врача
  doctorNameShort: null, // краткое имя врача
  doctorSpecialtyId: null, // id выбранной специальности
  hasSpecialPlacement: 0, // наличие спец. размещения. Если значение 1, значит нужно редиректить в форму записи с get параметром со значением 1. Иначе - не передавать get параметр
  wpListAppType: [], // список типов записи (ОЗ || ЭЗ) всех workplaces врача
  lpuWorkingText: '', // текст ближайшего времени приема
  wpListLpuWorkingText: [], // список текстов ближайшего времени приема по workplace
  wpListLpuPhone: [], // список телефонов клиник по workplace
})

type ServiceServiceData = {
  allowTreatmentReferral: boolean
  requiresPrimaryConsultation: boolean
  hasPrimaryConsultationDoctors: boolean
  doctorSpecialities: never[]
}

export const getServicesItemInterface = (): {
  lpuPhone: string
  lpuId: number | null
  serviceIsDirect: boolean | null
  serviceIsExpress: boolean | null
  serviceIsAvailable: boolean | null
  isEnabledLpuClub: boolean | null
  lpuWorkingText: string
  synonymPreview: {
    id: number | null
    name: string | null
    price: number | null
    dtypeId: number | null
    serviceData: ServiceServiceData
    hasIntervals: boolean | null
    priceWithDiscount: number | null
  }
} => ({
  lpuPhone: '', // номер телефона клиники
  lpuId: null, // id клиники
  serviceIsDirect: null, // включена ли 'Онлайн' запись в клинику
  serviceIsExpress: null, // включена ли 'Экспресс' запись в клинику
  serviceIsAvailable: null, // доступна ли запись в клинику
  isEnabledLpuClub: null, // активен ли клубный договор lpu
  lpuWorkingText: '', // текст ближайшего времени приема
  synonymPreview: { // 1 синоним для вывода превью
    id: null, // id синонима
    name: null, // название синонима
    price: null, // цена синонима со скидкой 'club'
    dtypeId: null, // привязанный dtype id к синониму
    serviceData: {
      allowTreatmentReferral: false,
      requiresPrimaryConsultation: false,
      hasPrimaryConsultationDoctors: false,
      doctorSpecialities: [],
    },
    hasIntervals: null, // наличие слотов синонима
    priceWithDiscount: null, // полная цена, без скидки
  },
})

export const getDoctorsLpuItemInterface = (): {
  lpuId: number | null
  doctorId: number | null
  hasSlots: boolean | null
  doctorFio: string | null
  doctorNameShort: string | null
  isAppointmentOn: boolean | null
  isExpress: string | null
  isDirect: string | null
  appointmentType: string
  lpuWorkingText: string
  lpuPhone: string
} => ({ // для страниц с запросом календарей врачей клиники
  lpuId: null, // id клиники
  doctorId: null, // id врача
  hasSlots: null, // наличие слотов у врача
  doctorFio: null, // полное имя врача
  doctorNameShort: null, // краткое имя врача
  isAppointmentOn: null, // включен ли вывод слотов в клинике
  isExpress: null, // флаг экспресс-записи
  isDirect: null, // флаг прямой записи
  appointmentType: '', // тип записи (ОЗ/ЭЗ)
  lpuWorkingText: '', // текст ближайшего времени приема
  lpuPhone: '', // номер телефона клиники
})

export const getNodesItemInterface = (): {
  coverNode: unknown
  scheduleNode: unknown
  scheduleNodeHTML: unknown
} => ({ // примесь для интерфейсов, список узлов, которые в итоге будут добавлены каждому интерфейсу Item
  coverNode: null, // узел-обертка, у которого найден атрибут dataItem
  scheduleNode: null, // узел, в который в итоге нужно монтировать календарь
  scheduleNodeHTML: null, // содержимое узла, в который в итоге нужно монтировать календарь(используется на услугах)
})
